<header class="header">
  <div class="header-container">
    <div class="header-content">
      <button
        type="button"
        class="mobile-menu-toggle"
        (click)="onSidebarToggle()"
        [attr.aria-label]="sidebarOpen ? 'Close menu' : 'Open menu'"
        [attr.aria-expanded]="sidebarOpen"
      > 
        <i class="fas" [class.fa-bars]="!sidebarOpen" [class.fa-times]="sidebarOpen"></i>
      </button>
      <div class="logo-container">
        <img src="assets/images/Greenwashing_ICON2.png" alt="Logo" class="logo">
      </div>
      <div class="header-text">
        <h1 class="header-title">ESG Integral</h1>
        <p class="header-subtitle">A Data Science Approach to Evaluating ESG Integrity</p>
      </div>
    </div>
    <div class="header-actions">
      <div class="header-time" aria-label="Current time">
        <i class="fas fa-clock"></i>
        <span>{{ currentTime }}</span>
      </div>
      <button class="theme-toggle" (click)="toggleTheme()" [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'" title="Toggle theme">
        <i class="fas" [class.fa-sun]="isDarkMode" [class.fa-moon]="!isDarkMode"></i>
      </button>
    </div>
  </div>
</header>
